import { useEffect, useState } from 'react';
import { MIN_TERMINAL_BUTTONS, MIN_MAX_BUTTONS, getPageNumbers } from '../utils/pagination';
const usePagination = ({
  activePage,
  maxButtons,
  terminalButtons,
  totalPages
}) => {
  const [maxButtonsDisplayed, setMaxButtonsDisplayed] = useState();
  const [terminalButtonsDisplayed, setTerminalButtonsDisplayed] = useState();
  const updateButtonsDisplayedFromWindowSize = () => {
    var _window;
    const isSmallerThanTablet = ((_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth) < 768;
    if (isSmallerThanTablet) {
      setMaxButtonsDisplayed(MIN_MAX_BUTTONS);
      setTerminalButtonsDisplayed(MIN_TERMINAL_BUTTONS);
    } else {
      setMaxButtonsDisplayed(maxButtons);
      setTerminalButtonsDisplayed(terminalButtons);
    }
  };
  useEffect(() => {
    setMaxButtonsDisplayed(Math.max(maxButtons, MIN_MAX_BUTTONS));
    setTerminalButtonsDisplayed(Math.max(terminalButtons, MIN_TERMINAL_BUTTONS));
  }, [maxButtons, terminalButtons]);
  useEffect(() => {
    var _window2;
    updateButtonsDisplayedFromWindowSize();
    (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.addEventListener('resize', updateButtonsDisplayedFromWindowSize);
    return () => {
      var _window3;
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.removeEventListener('resize', updateButtonsDisplayedFromWindowSize);
    };
  }, []);
  return getPageNumbers({
    activePage,
    maxButtons: maxButtonsDisplayed,
    terminalButtons: terminalButtonsDisplayed,
    totalPages
  });
};
export default usePagination;